import React, { useEffect, useState } from "react";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { API_URL, TOKEN } from "../../../variables/constants";


const AddPretiumDoloris = ({
  show,
  handleClose,
  editMode = false,
  selectedItem = null,
  items = [],
  onAdd,
  onUpdate,
}) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    qualification: "",
    points: "",
    moral: false,
  });

  useEffect(() => {
    if (editMode && selectedItem) {
      setFormData({
        qualification: selectedItem.qualification ?? "",
        points: selectedItem.points ?? "",
        moral: Boolean(selectedItem.moral),
      });
    } else {
      setFormData({ qualification: "", points: "", moral: false });
    }
  }, [editMode, selectedItem, show]);

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((f) => ({ ...f, [name]: type === "checkbox" ? checked : value }));
  };

  const validate = () => {
    const { qualification, points } = formData;
    if (!qualification.trim()) {
      toast.warning("La qualification est requise.");
      return false;
    }
    if (points === "" || Number.isNaN(Number(points)) || Number(points) < 0) {
      toast.warning("Les points doivent être un nombre positif ou nul.");
      return false;
    }
    return true;
  };

  // Doublon sur 'qualification' (création)
  const isDuplicateOnCreate = () => {
    const norm = (formData.qualification || "").trim().toLowerCase();
    return items?.some(
      (it) => (it.qualification || "").trim().toLowerCase() === norm
    );
  };

  const resetAndClose = () => {
    setFormData({ qualification: "", points: "", moral: false });
    handleClose && handleClose();
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    if (!editMode && isDuplicateOnCreate()) {
      toast.error("Une entrée avec cette qualification existe déjà.");
      return;
    }

    setLoading(true);
    const base = {
      qualification: formData.qualification.trim(),
      points: Number(formData.points),
      moral: Boolean(formData.moral),
    };

    const headers = {
      Authorization: `Bearer ${TOKEN}`,
      "Content-Type": "application/json",
    };

    try {
      if (editMode) {
        const payload = { ...selectedItem, ...base }; // inclut pretiumDolorisId
        const res = await axios.put(`${API_URL}/api/pretium-doloris`, payload, { headers });
        toast.success("Pretium Doloris modifié avec succès.");
        onUpdate && onUpdate(res.data);
      } else {
        const res = await axios.post(`${API_URL}/api/pretium-doloris`, base, { headers });
        toast.success("Pretium Doloris ajouté avec succès.");
        onAdd && onAdd(res.data);
      }
      resetAndClose();
    } catch (err) {
      console.error(err);
      toast.error("Erreur lors de l'enregistrement.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Body>
        <button type="button" className="btn-close btn-primary" onClick={handleClose} />
        <div className="text-center mb-4">
          <h4>{editMode ? "Modifier" : "Ajouter"} un Pretium Doloris</h4>
          <p className="address-subtitle">
            {editMode ? "Mettre à jour" : "Créer"} une ligne de pretium doloris
          </p>
        </div>

        <form className="row g-3" onSubmit={onSubmit}>
          <div className="col-md-8">
            <label className="form-label">Qualification</label>
            <input
              type="text"
              className="form-control"
              name="qualification"
              value={formData.qualification}
              onChange={onChange}
              required
            />
          </div>

          <div className="col-md-4">
            <label className="form-label">Points</label>
            <input
              type="number"
              className="form-control"
              name="points"
              value={formData.points}
              onChange={onChange}
              min="0"
              required
            />
          </div>

          <div className="col-md-12">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="moralCheck"
                name="moral"
                checked={formData.moral}
                onChange={onChange}
              />
              <label className="form-check-label" htmlFor="moralCheck">
                Préjudice moral ?
              </label>
            </div>
          </div>

          <div className="col-12 d-flex gap-2 mt-3">
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" />
                  Enregistrement...
                </>
              ) : (
                "Enregistrer"
              )}
            </button>
            <button type="button" className="btn btn-outline-secondary" onClick={handleClose}>
              Annuler
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default AddPretiumDoloris;
